import React, { useMemo } from 'react';
import Dashboard from '../../Dashboard/Dashboard';
import { Flex, Spinner } from '@patternfly/react-core';
import { useTranslation } from '../../../localization/useTranslation';
import { adjustDashboard, useDashboardQuery } from 'components/Dashboard/useDashboardsQuery';

const NodeDashboard = ({ dashboard, dashboardDate }) => {
  const T = useTranslation();

  const query = useDashboardQuery(dashboard?.id);

  const loadingDescription = query.isError ? T.common.error.generic : T.common.loading;
  const adjustedDashboard = useMemo(() => query.data ? adjustDashboard(query.data) : {}, [query.data]);

  return (
    <>
      { query.isLoading && <Flex alignItems={{ default: 'alignItemsCenter' }}>
        <Spinner size="md" />
        <span>{ loadingDescription }</span>
      </Flex>
      }
      <Dashboard dashboard={adjustedDashboard} dashboardDate={dashboardDate} />
    </>
  );
};

export default React.memo(NodeDashboard);
